import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function useResetSessionStorageOnLocationChange(
  pathname,
  sessionStorageItem,
  // IF FALSE OR UNDEFINED FUNCTION DOESNT WORK ON pathname
  // IF TRUE FUNCTION WORKS ON pathname
  boolean
) {
  const history = useHistory();

  useEffect(() => {
    if (boolean === undefined || !boolean) {
      return history.listen((location) => {
        if (location.pathname.includes(pathname)) {
          return null;
        } else {
          sessionStorage.removeItem(sessionStorageItem);
        }
      });
    } else {
      return history.listen((location) => {
        if (location.pathname.includes(pathname)) {
          sessionStorage.removeItem(sessionStorageItem);
        }
      });
    }
  });
}
